import { TFunction } from 'i18next';
import { ListRowProps } from '../../../../../tools';
import { ApplicationResponse } from '../../../../../types';
import { useFormatLocaleDate } from '../../../../../config';

export const useImportantDates = (
  t: TFunction,
  application?: ApplicationResponse
): ListRowProps[] => {
  const formatLocaleDate = useFormatLocaleDate();
  const renderFormattedDate = (value: Date | undefined) =>
    value ? formatLocaleDate(value) : '-';
  return [
    {
      label: t('application_received', 'Application received'),
      value: renderFormattedDate(application?.dateReceived),
    },
    {
      label: t('application_validated', 'Application validated'),
      value: renderFormattedDate(application?.dateValidated),
    },
    {
      label: t('last_neighbour_consultation', 'Last neighbour consultation'),
      value: renderFormattedDate(application?.latestNeighbourConsultationDate),
    },
    {
      label: t('neighbour_consultation_expiry', 'Neighbour consultation expiry'),
      value: renderFormattedDate(application?.neighbourConsultationExpiryDate),
    },
    {
      label: t('standard_consultation', 'Standard consultation'),
      value: renderFormattedDate(application?.standardConsultationDate),
    },
    {
      label: t('standard_consultation_expiry', 'Standard consultation expiry'),
      value: renderFormattedDate(application?.standardConsultationExpiry),
    },
    {
      label: t('date_last_advertised', 'Date last advertised'),
      value: renderFormattedDate(application?.dateLastAdvertised),
    },
    {
      label: t('latest_advert_expiry_date', 'Latest advertisement expiry date'),
      value: renderFormattedDate(application?.latestAdvertisementExpiryDate),
    },
    {
      label: t('decision_issued', 'Decision issued'),
      value: renderFormattedDate(application?.decisionDate),
    },
    {
      label: t('permission_expiry', 'Permission expiry'),
      value: renderFormattedDate(application?.permissionExpiryDate),
    },
    {
      label: t('committee', 'Committee'),
      value: renderFormattedDate(application?.committeeDate),
    },
    {
      label: t('application_called_into_committee', 'Application called into committee'),
      value: renderFormattedDate(application?.applicationCalledInDate),
    },
    {
      label: t('department_referral', 'Department referral'),
      value: renderFormattedDate(application?.departmentReferralDate),
    },
  ];
};
